var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import tokens from '@gympass/yoga-tokens';
import { css } from 'styled-components';
import { not } from './media';
var breakpoints = tokens.breakpoints;
var availableBreakpoints = Object.entries(breakpoints);

var hide = function hide(isNot) {
  return availableBreakpoints.reduce(function (acc, _ref, index) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        breakpoint = _ref2[1];

    if (index === 0) {
      var _availableBreakpoints = _slicedToArray(availableBreakpoints[index + 1], 2),
          secondBreakpoint = _availableBreakpoints[1];

      acc[key] = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        @media ", " (max-width: ", "px) {\n          display: none !important;\n        }\n      "])), not(isNot), secondBreakpoint.width);
      acc["".concat(key, "-start")] = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        @media ", " (min-width: ", "px) {\n          display: none !important;\n        }\n      "])), not(isNot), breakpoint.width);
      return acc;
    }

    if (index === availableBreakpoints.length - 1) {
      acc[key] = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        @media ", " (min-width: ", "px) {\n          display: none !important;\n        }\n      "])), not(isNot), breakpoint.width);
      return acc;
    }

    var _availableBreakpoints2 = _slicedToArray(availableBreakpoints[index + 1], 2),
        nextBreakpoint = _availableBreakpoints2[1];

    acc[key] = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      @media ", " (min-width: ", "px) and (max-width: ", "px) {\n        display: none !important;\n      }\n    "])), not(isNot), breakpoint.width, nextBreakpoint.width - 1);
    acc["".concat(key, "-start")] = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      @media ", " (min-width: ", "px) {\n        display: none !important;\n      }\n    "])), not(isNot), breakpoint.width);
    return acc;
  }, {});
};

export default hide;